// Import Global Filtersser
import dateFilterShort from '../app/filters/date/0001/defaultDateFilterShort'
import dateFilterLong from '../app/filters/date/0001/defaultDateFilterLong'
import dateFilterCustom from '../app/filters/date/0001/defaultDateFilterCustom'
import dateFilterDateTime from '../app/filters/date/0001/defaultDateFilterDateTime'

export default function(app, Vue) {
  Vue.filter('dateFilterCustom', dateFilterCustom)
  Vue.filter('dateFilterShort', dateFilterShort)
  Vue.filter('dateFilterLong', dateFilterLong)
  Vue.filter('dateFilterDateTime', dateFilterDateTime)
  Vue.filter('slice', (value, count, start = 0) => {
    if (!value) {
      return ''
    }
    value.slice(start, start + count)
  })
  Vue.filter('truncate', (value, count) => {
    if (!value) {
      return ''
    }
    return (value.slice(0, count) + ((value.length > count) ? '...' : ''))
  })
  Vue.filter('bytes', (value, unit, decimals = 2) => {
    switch (unit.toLowerCase()) {
    case 'kb':
      return `${(value / 1024).toFixed(decimals)}KB`
    case 'mb':
      return `${(value / (1024 ** 2)).toFixed(decimals)}MB`
    case 'gb':
      return `${(value / (1024 ** 3)).toFixed(decimals)}GB`
    default:
      return `${value.toFixed(decimals)}B`
    }
  })
  Vue.filter('toUrl', (value) => {
    return (/^(\/|http:\/\/|https:\/\/)/i.test(value)) ? value : `//${value}`
  })
}
